module.exports = __webpack_public_path__ + "static/media/localtunnel.9b9881a9.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/localtunnel.ico
// module id = 139
// module chunks = 0